// extracted by mini-css-extract-plugin
export default {"price":"J4-z","onSale":"K4-z","msrpLabelPrice":"L4-z","msrpLabel":"M4-z","originalPrice":"N4-z","percentOff":"O4-z"};